import React from "react";
import { SignedInDoctor, UnloggedDoctor } from "./auth/interfaces";
 export const BASE_BE_URL: string = "";
// export const BASE_BE_URL: string = "http://192.168.0.202:3333"; //mobile mode
// export const BASE_BE_URL: string = "http://localhost:3333";


export interface SignedInContextType {
  signedInDoctor: SignedInDoctor;
  setSignedInDoctor: any;
}

export const SignedInContext: React.Context<SignedInContextType> =
  React.createContext({
    signedInDoctor: UnloggedDoctor,
    setSignedInDoctor: undefined,
  });
